<template>
    <div>
        <CamparatorNav :isMobile="isMobile" :type="this.$route.params.type"/>
        <ComparatorBody :isMobile="isMobile" :type="this.$route.params.type" :cardData="returData"/>
    </div>
</template>
<script>
    import { mapGetters, mapState } from 'vuex'
    import CamparatorNav from '../components/TemplateParts/SimpleContent/CamparatorNav.vue'
    import ComparatorBody from'../components/TemplateParts/ComparatorBody/ComparatorBody.vue'
    import { windowResized } from '../mixins/windowEventListeners'

    export default {
        name: 'Comparator',
        components:{ CamparatorNav, ComparatorBody },
        mixins: [windowResized],
        provide:{ page: 'Comparator'},
        data(){return{

        }},
        mounted(){
            let nav = document.querySelector('.navbar');
            if(nav){ nav.style.display = 'flex' }
        },
        computed:{
            ...mapState(['resumeData']),
            ...mapGetters({
                getMotors: 'enginesData/getEngines',
                getVersions: 'versionsData/getModelVersions',
            }),
            returData(){
                return (this.$route.params.type == 'Motor') ?
                    this.getMotors(this.resumeData.modelid) :
                    this.getVersions(this.resumeData.modelid, this.resumeData.engineID);
            },
        },
    }
</script>